import { ProtocolItemModel } from 'shared/domain/inspection/inspectionModel';

export function protocolItemsByChecklistItemId(
  protocolItems: ProtocolItemModel[] | undefined
): Map<string, ProtocolItemModel> {
  if (!protocolItems?.length) {
    return new Map();
  }

  return new Map(
    protocolItems.map((protocolItem) => [
      protocolItem.templateChecklistItem,
      protocolItem,
    ])
  );
}
